import axios from "axios";
const axiosInstance = axios.create({
  // baseURL: "http://192.168.0.241:5678/",
  baseURL: "https://api.shriadithyahospitals.com/",
});
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  return config;
});
export default axiosInstance;
